/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_4_MetaInputs */

const en_mk_start_4_meta = /** @type {(inputs: Mk_Start_4_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the days after`)
};

const id_mk_start_4_meta = /** @type {(inputs: Mk_Start_4_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hari-hari berikutnya`)
};

/**
* | output |
* | --- |
* | "the days after" |
*
* @param {Mk_Start_4_MetaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_4_meta = /** @type {((inputs?: Mk_Start_4_MetaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_4_MetaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_4_meta(inputs)
	return en_mk_start_4_meta(inputs)
});